import styled from 'styled-components';
import { StyledButton } from '../../../../components';

export const StyledB2BConnectLayer = styled.div`
  display: none;

  @media (min-width: ${props => props.theme.screen.md}) {
    justify-self: start;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 8px;
  }
`;

export const StyledB2BConnectPro = styled.span`
  font-weight: 700;
  text-transform: uppercase;
`;

export const StyledB2BConnectText = styled.span`
  text-decoration: underline;
  margin-left: 3px;
`;

export const StyledB2BConnectButton = styled(StyledButton)`
  margin-left: 10px;
  padding: 3px 12px;
  height: 32px;

  @media (max-width: $header-screen-lg) and (min-width: $header-screen-md) {
    width: 124px;
    font-size: 12px;
  }
`;
